import { Injectable } from '@angular/core';
import { PhaseCompletedModalComponent } from '@modules/onboarding/components/phase-completed-modal/phase-completed-modal.component';
import { PhaseDetailModalComponent } from '@modules/onboarding/components/phase-detail-modal/phase-detail-modal.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { OnboardingPhase } from '../interfaces/onboarding.interfaces';

@Injectable({
    providedIn: 'root',
})
export class OnboardingModalService {
    private readonly baseOptions: NgbModalOptions = {
        centered: true,
        backdrop: true,
        keyboard: true,
        backdropClass: 'fina-onboarding-backdrop',
        windowClass: 'fina-onboarding-modal-window',
    };

    constructor(private modalService: NgbModal) {}

    openPhaseDetail() {
        return this.modalService.open(PhaseDetailModalComponent, {
            ...this.baseOptions,
            size: 'md',
        });
    }

    openPhaseCompleted(phase?: OnboardingPhase) {
        const modalRef = this.modalService.open(PhaseCompletedModalComponent, {
            ...this.baseOptions,
            size: 'md',
        });

        if (phase) {
            modalRef.componentInstance.phase = phase;
        }

        return modalRef;
    }
}
